import Vue from 'vue'
import Vuex from 'vuex'
import service from '../../services/gestionTiempos/autoriz'
import autoriz from '../../models/gestionTiempos/autoriz'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        service: new service(),
        date: null,
        autoriz:[],
        newAutoriz:{},
        deleteItem:{},
        editItems:[],
        coment:[],
        itemToEdit: [],
    },
    mutations: {
        setDate(state, date) {
            state.date = date
        },
        setAutoriz(state,data){
            state.autoriz = data 
        },
        setNewAutoriz(state,data){
            state.newAutoriz = data
           
        },
        setDeleteItem(state,data){
            state.deleteItem = data
     
        },
        setEdit(state, options) {
          state.editItems = options
  
        },
        setComent(state,data){
          state.coment=data
        },
        setItemToEdit(state,data){

          state.itemToEdit = data
        },
    },
    actions: {
     
        async getAutoriz(state) {
          return new Promise(async (resolve, reject) => {
            try {
              let item = await state.state.service.getAutoriz(state.state.date)
              state.commit('setAutoriz',  item )
              resolve(true)
          } catch (error) {
            reject(error)
          }
          })
           
        },
        async getComent(state) {
          return new Promise(async (resolve, reject) => {
            try {
              let item = await state.state.service.getComentNov()
                 
              state.commit('setComent',  item )
              resolve(true)
          } catch (error) {
            reject(error)
          }
          })
           
        },
       
        async getNewAutoriz(state) {
            return new Promise(async (resolve, reject) => {
              try {
                await state.state.service.new(state.state.newAutoriz).then((data) => {
                  let items = state.state.newAutoriz
            
                  let options = state.state.autoriz
                  
                  let newItem = autoriz.fromJson({
                    ComentId: items.comentId,
                    Coment:items.coment,
                    Desde:items.from,
                    Hasta:items.to,
                    Fecha:items.date,
                    EmpId:items.empId,
                  
                  })
       
                  options.push(newItem)
                  state.commit('setAutoriz', options)
                  resolve(true)
                })
        
              }
              catch (error) {

                reject(error)
              }
            })
           
          },
          async deleteAutoriz(state) {
            return new Promise(async (resolve, reject) => {
              try {
                await state.state.service.delete(state.state.deleteItem).then(() => {
                  let options = state.state.autoriz
               
                  options = options.filter(option => {
                    return option.originalFrom != state.state.deleteItem.from
                  })
        
                  state.commit('setAutoriz', options)
                  resolve(true)
                });
              } catch (error) {
                reject(error)
        
              }
            })
           
          },
          async edit(state) { 
            return new Promise(async (resolve, reject) => {
              try {
                await state.state.service.edit(state.state.editItems).then(() => {
                  let item = state.state.editItems
             
              let options = state.state.autoriz
                 
            
             
             
                  options = options.map(option => {
                    if (option.originalFrom != state.state.editItems.desde) {
                 
                      return option
                    }
                    item = autoriz.fromJson({
                      ComentId: item.comentId,
                      Coment:item.coment,
                      Desde:item.timeFrom,
                      Hasta:item.timeTo,
                      Fecha:item.date,
                      EmpId:item.empId,
                    
                    })
                    return item;
        
                  })
        
        
                  state.commit('setAutoriz', options)
                  resolve(true)
                })
              }
              catch (error) {
                reject(error)
              }
            })
           
          }
       
    },
   


})